import { getCountries } from 'libphonenumber-js/min'
import type { CountryCode } from 'libphonenumber-js/min'
import metadata from 'libphonenumber-js/min/metadata'

/**
 * The phone inputs' default flag for the salon: its own ISO country (company
 * settings `country_iso2`) first; else the MAIN country of its calling code as
 * libphonenumber orders them ("7" → RU, not KZ; "358" → FI, not AX; "1" → US);
 * else `fallback`. A first alphabetical match used to show a Russian salon as
 * Kazakhstan.
 */
export function salonPhoneCountry(
  iso2?: string | null,
  callingCode?: string | null,
  fallback: CountryCode = 'BY',
): CountryCode {
  const known = new Set<string>(getCountries())
  const iso = (iso2 ?? '').trim().toUpperCase()
  if (known.has(iso)) return iso as CountryCode
  const code = (callingCode ?? '').trim().replace(/^\+/, '')
  const main = (metadata.country_calling_codes as Record<string, string[]>)[code]?.[0]
  if (main && known.has(main)) return main as CountryCode
  return fallback
}
